import React, { useState, useEffect } from "react";
import ViewingRateChart from "./ViewingRateChart";
import RankingList from "./RankingList";
import noimage from "../../../../assets/img/noimage.jpg";
import { useNavigate } from "react-router-dom";
import { fetchTopNews } from "../../../reducers/companyContentManage"
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { PERMISSIONS } from '../../../constants/index';
import CustomButton from "../../../components/CustomButton";

const NewsContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const currentUser = useSelector((state: any) => state.currentUser);
  const { staffPermission } = currentUser;
  const {
    loading,
    success,
    error,
    topNews,
  } = useSelector((state: any) => state.companyContentManage);

  useEffect(() => {
    const data = "";
    dispatch(fetchTopNews(data));
  }, [dispatch]);

  interface topNewsItem {
    id: number;
    img: string;
    title: string;
    views: string;
    description: string;
    ranking?: number;
    action: {
      name: string;
    };
  }

  const topNewsList: topNewsItem[] = topNews.map((item: any) => ({
      ...item,
      img: item.images ? item.images : noimage,
      description: item.contents,
      views: new Intl.NumberFormat().format(item.pv) + "PV",
      action: { name: "編集" },
  }));

  return (
    <>
      <div className="flex items-center mb-4">
        <h1 className="text-xl font-bold leading-[1.875rem] alu-text-base-2">
          ニュース
        </h1>
        {staffPermission[PERMISSIONS.NEWS_NEW] && (
        <CustomButton
          onClick={() => navigate("/company/news/register")}
          type="button"
          variant="outline"
          customStyle="ml-8"
          size="sm"
        >
          ニュースを追加
        </CustomButton>
        )}
      </div>
      <div className="flex gap-4">
        <div>
          <ViewingRateChart />
        </div>
        <div className="flex-1">
          <RankingList list={topNewsList} />
        </div>
      </div>
    </>
  );
};

export default NewsContent;
